input{padding:0 11px;border:1px solid #d9d9d9;height:32px}.ctParameters-submitted .ctParameters.ng-invalid{border:red 1px solid!important;border-radius:2px}
/*# sourceMappingURL=ct-parameters-add-edit.component-DB5LGCAT.css.map */
